import {
    SEARCH_RESULT_RECEIVE,
} from '../ConstantsBrafab/constants';

export const searchTabs = (
    state = { 
        inspirationTotalCount: 0,
        sparepartsTotalCount: 0,
        pagesTotalCount: 0,
        productsTotalCount: 0,
        activeTabName: ''
    },
    action
) => {
    switch (action.type) {
        case SEARCH_RESULT_RECEIVE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
